export default __webpack_public_path__ + "static/media/education1.16d22790.jpg";